import React from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import Question from './Question.js'
import './style.css'
import { Button } from 'react-bootstrap'


// Quizzes
import feelingsQuiz from './me-and-my-feelings';
import myths from './myths';

export default class QuizSection extends React.Component {
  constructor (props) {
    super(props)
  }


  render() {
    let landing = null;
    if (this.props.location.pathname === "/youth/quiz" || this.props.location.pathname === "/youth/quiz/") {
      landing = (
        <div className="quiz-container">
          <div className="quiz">
            <h2>Me and My Feelings Quiz</h2>
            <Button className="quiz-btn" href="/youth/quiz/feelings">Take Quiz</Button>
          </div>
          <div className="quiz">
            <h2>Myth Busters Quiz</h2>
            <Button className="quiz-btn" href="/youth/quiz/myths">Take Quiz</Button>
          </div>
        </div>
      )      

      
    }

    return (
      <div className="">
        <Router>
          <Switch>
            <Route path="/youth/quiz/feelings" component={feelingsQuiz} />
            <Route path="/youth/quiz/myths" component={myths} />
          </Switch>
        </Router>
        {landing}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Quiz/index.js